<script setup>
import { computed} from 'vue';
const { justify, align, gap } = defineProps({
    justify: {
        type: String,
        default: 'flex-start'
    },
    align: {
        type: String,
        default: 'flex-start'
    },
    gap: {
        type: Number,
        default: 0
    }
})

const style = computed(() => {
    return {
        '--justify': justify,
        '--align': align,
        '--gap': gap + 'px'
    }
})
</script>

<template>
    <div class="flex" :style="style">
        <slot />
    </div>
</template>

<style scoped>
.flex {
    justify-content: var(--justify);
    align-items: var(--align);
    gap: var(--gap);
}
</style>